import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IntersectionObserverModule } from 'src/core-lib/intersection-observer/intersection-observer.module';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { CarouselComponent, CarouselItemDirective, CarouselThumbDirective } from './components/carousel/carousel.component';
import { ImageZoomComponent } from './components/image-zoom/image-zoom.component';
import { SvgComponent } from './components/svg/svg.component';
import { AriaDirective } from './directives/aria.directive';
import { AspectRatioDirective } from './directives/aspect-ratio.directive';
import { BackgroundImageDirective } from './directives/background-image.directive';
import { ImgDirective } from './directives/img.directive';
import { PictureDirective } from './directives/picture.directive';
import { VideoDirective } from './directives/video.directive';
import { ImageQueryPipe } from './pipe/image-query.pipe';
import { MediaTypePipe } from './pipe/media-type.pipe';
import { FALLBACK_URL, INITIAL_URL, LOADING_URL, SVG_DEF } from './tokens';
import { DialogModule } from '../dialog/dialog.module';



@NgModule({
    declarations: [
        ImgDirective,
        SvgComponent,
        BackgroundImageDirective,
        VideoDirective,
        ImageQueryPipe,
        MediaTypePipe,
        AspectRatioDirective,
        CarouselComponent,
        ImageZoomComponent,
        AriaDirective,
        CarouselItemDirective,

        CarouselThumbDirective,
        PictureDirective,
    ],
    imports: [
        CommonModule,
        IntersectionObserverModule,
        DialogModule,
    ],
    exports: [
        ImgDirective,
        SvgComponent,
        BackgroundImageDirective,
        VideoDirective,
        ImageQueryPipe,
        MediaTypePipe,
        AspectRatioDirective,
        CarouselComponent,
        ImageZoomComponent,
        AriaDirective,
        CarouselItemDirective,
        DialogModule,
        CarouselThumbDirective,
        PictureDirective,
    ]
})
export class MediaModule {
    static forRoot(svg_def: { [key: string]: string }): ModuleWithProviders<MediaModule> {
        return {
            ngModule: MediaModule,
            providers: [
                {
                    provide: SVG_DEF,
                    useValue: svg_def ?? {}
                },
                {
                    provide: INITIAL_URL,
                    useFactory: (contentCacheService: ContentCache) => {
                        const url = contentCacheService.get<{ theme: { initialUrl: UmbracoImage } }>('mainConfiguration')?.theme?.initialUrl?.imageUrl;
                        return url != null ? url : '/dist/assets/loading.svg';
                    },
                    deps: [ContentCache]
                },
                {
                    provide: LOADING_URL,
                    useFactory: (contentCacheService: ContentCache) => {
                        const url = contentCacheService.get<{ theme: { loadingUrl: UmbracoImage } }>('mainConfiguration')?.theme?.loadingUrl?.imageUrl;
                        return url != null ? url : '/dist/assets/loading.svg';
                    },
                    deps: [ContentCache]
                },
                {
                    provide: FALLBACK_URL,
                    useFactory: (contentCacheService: ContentCache) => {
                        const url = contentCacheService.get<{ theme: { fallbackUrl: UmbracoImage } }>('mainConfiguration')?.theme?.fallbackUrl?.imageUrl;
                        return url != null ? url : '/dist/assets/no-image.svg';
                    },
                    deps: [ContentCache]
                },

            ]
        };
    }
}
